import React, { useEffect, useState } from "react";
import BackgroundDiv from "../misc/elements/BackgroundDiv";
import { objectToArray, round } from "../misc/helperfuncs";

const DetailedMoods = ({
  moodObject,
  imgSize = "30px",
  fontSize = "15px",
  isSeconds = false,
}) => {
  const [moodArray, setMoodArray] = useState([]);

  useEffect(() => {
    var array = objectToArray(moodObject ?? {});
    if (isSeconds)
      array = array.map((kv) => {
        return { ...kv, value: round(kv.value / 60) };
      });
    setMoodArray(array);
  }, [moodObject]);

  return (
    <div className="divColumn" style={{ width: "100%" }}>
      <div
        className="divRow"
        style={{
          position: "relative",
          width: "100%",
          justifyContent: "center",
        }}
      >
        <BackgroundDiv backgroundColor={"#2f2f2f"} borderBottom={true} />
        <div className="textBoldWhite" style={{ zIndex: 1 }}>
          Moods
        </div>
      </div>
      <div
        className="divRow"
        style={{
          justifyContent: "space-around",
          width: "100%",
          position: "relative",
        }}
      >
        <BackgroundDiv backgroundColor={"#9f9f9f"} borderTop={true} />
        <div
          className="divRow"
          style={{
            zIndex: 1,
            width: "100%",
            justifyContent: "space-around",
            paddingTop: "5px",
          }}
        >
          {moodArray.map((mood, index) => (
            <MoodHolder
              mood={mood}
              index={index}
              key={index}
              imgSize={imgSize}
              fontSize={fontSize}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

const MoodHolder = ({ mood, index, imgSize, fontSize }) => {
  return (
    <div className="divColumn">
      <img
        src={`/icons/icon_${mood.key}.png`}
        style={{ objectFit: "contain", height: imgSize }}
      />
      <div className="divRow">
        <img className="icon20" src="/icons/icon_time.png" />
        <div className="textBold" style={{ fontSize }}>
          {mood.value}
        </div>
      </div>
    </div>
  );
};

export default DetailedMoods;
